import styled from 'styled-components';

import SelectDef from 'components/SelectNew';

export const Select = styled(SelectDef)`
  margin-bottom: 20px;
`;
